export default {
  startLoading: 'Rozpocznij załadunek',
  finishLoading: 'Zakończ załadunek',
  loadEditDisabled: 'Można edytować tylko obciążenie "planowane".',
};
